import { useCapitalGlobalProposalStep1Form } from '@/features/proposals/components/capital-global/steps/capital-global-proposal-step1-form.context';
import { CapitalGlobalProposalSubStipulantAddressRow } from '@/features/proposals/components/capital-global/steps/sections/capital-global-proposal-sub-stipulant-address-row.component';
import { Text } from '@noorden-insurtech/alba-design-system';

/**
 * Endereço de cadastro de cada subestipulante.
 *
 * O i4Pro exige um `idEndereco` por item de `subestipulantes[]` (erro 17) e esse id nasce
 * do cadastro de pessoa, que só recebe endereço quando o subestipulante traz CEP+número.
 * Sem esta seção, todo sub herdava o endereço do estipulante na apólice emitida.
 */
export function CapitalGlobalProposalSubStipulantAddressesSection() {
  const { form } = useCapitalGlobalProposalStep1Form();

  return (
    <form.Subscribe
      selector={state => state.values.subStipulatorAddresses.length}
      children={count => {
        if (count === 0) return null;

        return (
          <div className='flex flex-col gap-4'>
            <div className='flex flex-col gap-1'>
              <Text className='text-base font-normal text-alba-black-500'>
                Dados dos Subestipulantes
                <span className='text-alba-error-red-500'>*</span>
              </Text>
              <Text className='text-sm font-normal text-alba-black-400'>
                Informe os dados de cadastro de cada subestipulante.
              </Text>
            </div>

            {Array.from({ length: count }, (_, index) => (
              <CapitalGlobalProposalSubStipulantAddressRow
                key={index}
                index={index}
              />
            ))}
          </div>
        );
      }}
    />
  );
}
